export async function retryable(callback, { previousTimeout = null, retryCount = 0, generateTimeout, onError = () => undefined, }) {
    try {
        return await callback();
    }
    catch (e) {
        const retryTimeout = generateTimeout(previousTimeout, retryCount);
        onError(e, retryTimeout);
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(retryable(callback, {
                    previousTimeout: retryTimeout,
                    retryCount: retryCount + 1,
                    generateTimeout,
                    onError,
                }));
            }, retryTimeout);
        });
    }
}
//# sourceMappingURL=retryable.js.map